export default "__VITE_ASSET__BHiaA0Ob__"